( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-featured-posts-carousel', {
			direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 'auto',
			loop: true,
			noSwiping: false,

			navigation: {
				nextEl: '.js-carousel-nav-next',
				prevEl: '.js-carousel-nav-prev',
			},

			breakpoints: {
				1280: {
					slidesPerView: 4,
					spaceBetween: 20,
					noSwiping: true
				}
			},

			on: {
				beforeInit: function () {
					let numSlides = this.wrapperEl.querySelectorAll( '.js-carousel-slide' ).length;
					if ( numSlides <= 3 ) {
						this.params.loop = false;
					}
				},
				init: function () {
					checkOverflow(this);
				},
				resize: function () {
					checkOverflow(this);
				},
			}
		});
	} );

	function checkOverflow(swiperInstance) {
		const class_name = 'swiper--no-navigation'
		if (swiperInstance.isBeginning && swiperInstance.isEnd) {
			// All slides are visible, add a class to hide navigation
			swiperInstance.el.classList.add( class_name );
			swiperInstance.el.classList.add( class_name );
		} else {
			// Not all slides are visible, ensure navigation is shown
			swiperInstance.el.classList.remove( class_name );
		}
	}
} )( jQuery, document, window );
